import React from 'react'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import * as Styles from './styles'
import { FormattedMessage } from 'react-intl'
import { useIntegrations } from '../../../contexts/integrations.context'
import ExchangeIcon from '~/components/commons/ExchangeIcon'

export default function LinkLocationModal({
  type,
  location,
  data,
  integrationId: nisseiId,
  linkId,
}) {
  const [isOpen, setIsOpen] = React.useState(false)
  const toggle = () => setIsOpen(el => !el)
  const { setIntegration } = useIntegrations()
  const handleLink = async () => {
    if (type === 'linked') {
      await setIntegration(linkId, nisseiId)
    } else {
      await setIntegration(linkId, nisseiId, location.value)
    }
    toggle()
  }
  return (
    <>
      <Styles.Button
        onClick={toggle}
        disabled={!location}
        type={type === 'linked' ? 'unlink' : 'sync'}
      >
        {type === 'linked' ? (
          <FormattedMessage id={`Unlink Location`} />
        ) : (
          <FormattedMessage id={`Link Location`} />
        )}
      </Styles.Button>
      <Modal centered size="lg" isOpen={isOpen} toggle={toggle}>
        <ModalHeader toggle={toggle}>
          {type === 'linked' ? (
            <FormattedMessage id={`Unlink Location Modal Header`} />
          ) : (
            <FormattedMessage id={`Link Location Modal Header`} />
          )}
        </ModalHeader>
        <ModalBody>
          <Styles.BodyTitle>
            {type === 'linked' ? (
              <FormattedMessage id={`Unlink Location Modal Description`} />
            ) : (
              <FormattedMessage id={`Link Location Modal Description`} />
            )}
          </Styles.BodyTitle>
          <Styles.ModalInnerBody>
            <div className="icon--wrapper">
              <div className="icon-container">
                <ExchangeIcon />
              </div>
            </div>
            <div className="left">
              <div className="simple-badge">
                <span>
                  <FormattedMessage id={'External data'} />
                </span>
              </div>
              <div>
                <div>
                  <div className="cnpj-badge">
                    <span>{data.cnpj}</span>
                  </div>
                  <span className="title">{data.name}</span>
                </div>
                <span className="paragraph">
                  {data.address}, {data.neighborhood} - {data.city} /{' '}
                  {data.state}
                </span>
              </div>
            </div>
            <div className="right">
              <div className="simple-badge">
                <span>Google Business Profile:</span>
              </div>
              <div>
                <div>
                  <span className="title">{location?.label.name}</span>
                </div>
                <span className="paragraph">
                  {location?.label.address}, {location?.label.city} /{' '}
                  {location?.label.state}
                </span>
              </div>

              <a
                href={location?.label.mapsuri}
                className="link-to-location"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FormattedMessage id={`View Local on Google`} />
              </a>
            </div>
          </Styles.ModalInnerBody>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" outline onClick={toggle}>
            <FormattedMessage id={`Link Location Modal Footer Cancel`} />
          </Button>
          {'  '}
          <Button
            color={type === 'linked' ? 'danger' : 'success'}
            onClick={handleLink}
          >
            {type === 'linked' ? (
              <FormattedMessage id={`Unlink Location Modal Footer Submit`} />
            ) : (
              <FormattedMessage id={`Link Location Modal Footer Submit`} />
            )}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  )
}
